import React from 'react';
import { t } from '../i18n';

// Small formatting helpers shared across screens.

export const fmtDate = (d) =>
  new Date(d).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });

export const fmtMoney = (n) =>
  n != null ? `$${Number(n).toLocaleString('en-US', { minimumFractionDigits: 2 })}` : '—';

// Calendar-date-only formatter for values that came from an <input type="date">
// (license/insurance expiry, payment dates). Those are stored as UTC midnight,
// so rendering them in local time west of UTC shows the day before. Read as UTC.
export const fmtDay = (d) =>
  new Date(d).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' });

// Date + time, e.g. "Jul 15, 2:30 PM" — used for appointments.
export const fmtDateTime = (d) =>
  new Date(d).toLocaleString('en-US', { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' });

// "June 14, 2026" — the long form the technician portal puts under a row,
// in the language the tech is reading the app in.
export const fmtLongDate = (d, lang = 'en') =>
  new Date(d).toLocaleDateString(lang, { month: 'long', day: 'numeric', year: 'numeric' });

// Sort/group key for the month headings — "2026-06", zero-padded so plain
// string comparison orders months correctly.
export const monthKey = (d) => {
  const dt = new Date(d);
  return `${dt.getFullYear()}-${String(dt.getMonth() + 1).padStart(2, '0')}`;
};

// Heading above a month's rows. The current year is left off, so this year's
// work reads "June" and older work reads "June 2025".
export const fmtMonth = (d, lang = 'en') => {
  const dt = new Date(d);
  const sameYear = dt.getFullYear() === new Date().getFullYear();
  return dt.toLocaleDateString(lang, sameYear ? { month: 'long' } : { month: 'long', year: 'numeric' });
};

// Converts an ISO date to the value format a <input type="datetime-local"> needs.
export const toLocalInput = (d) => {
  if (!d) return '';
  const dt = new Date(d);
  const pad = (n) => String(n).padStart(2, '0');
  return `${dt.getFullYear()}-${pad(dt.getMonth() + 1)}-${pad(dt.getDate())}T${pad(dt.getHours())}:${pad(dt.getMinutes())}`;
};

// Renders a colored status pill for a request's status.
export const statusTag = (status) => {
  const map = {
    'new': 'tag-slate',
    'estimate-sent': 'tag-amber',
    'approved': 'tag-blue',
    'assigned': 'tag-teal',
    'in-progress': 'tag-blue',
    'completed': 'tag-green',
    'invoiced': 'tag-amber',
    'paid': 'tag-green',
  };
  const cls = map[status] || 'tag-slate';
  return <span className={`tag ${cls}`}>{t('status.' + status, status)}</span>;
};

// Picks a colored urgency dot class.
export const urgencyDot = (urgency) => {
  if (urgency?.includes('Urgent')) return 'dot-red';
  if (urgency?.includes('Soon')) return 'dot-amber';
  return 'dot-green';
};
